import React, { useState, useEffect } from "react";
import { Form, Button, message, Tooltip } from "antd";
import { Country, State } from "country-state-city";
import { useSelector, useDispatch } from "react-redux";

import {
  SUPPLIER_STATUS,
  VALIDATION_RULES,
  ERROR_MESSAGES,
  SUPPLIER_DETAILS_CONSTANTS,
  SupplierIdtooltipContent,
  API_BASE_URL,
} from "../../constants/Constants";
import {
  fetchSuppliers,
  updateContactDetails,
  updateAssociatedSuppliers,
} from "../../redux/slices/supplierFormSlice";
import FormInput from "../common/FormInput/FormInput";
import { validate } from "email-syntax-validator";

import { InfoCircleOutlined } from "@ant-design/icons";
import { setAdditionalDetails } from "../../redux/slices/signupSlice";
import axios from "axios";

const AdditionalDetails = ({ onAdd, initialValues, currentValue }) => {
  const [form] = Form.useForm();
  const [showFields, setShowFields] = useState(false);
  const [countries, setCountries] = useState([]);
  const dispatch = useDispatch();

  const {
    associatedSuppliers = [],
    supplierInfo = {},
    status = null,
    error = null,
  } = useSelector((state) => state.supplier || {});

  const { additionalDetails } = useSelector((state) => state.signup);

  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  useEffect(() => {
    currentValue.length === 0 && setShowFields(true);
  }, [currentValue]);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        supplierId: initialValues.supplierId,
        countryCode: initialValues.countryCode,
      });
      setShowFields(true);
    }
  }, [initialValues, form]);

  const onFinish = async(values) => {
    if (values.supplierId.length < 6) {
      values.supplierId = values.supplierId.padStart(6, 0);
    }
    const newSupplier = {
      supplierId: values.supplierId,
      countryCode: values.countryCode,
    };

    try {
      const response = await axios.post(API_BASE_URL+"/signup/associatedSupplierCheck", newSupplier);
      console.log(response);
      
      if (response.data.includes("already registered")) {
        message.warning("This supplier ID is already registered for this country");
        return;
      }
      onAdd({ associatedSuppliers: [newSupplier] });
      form.resetFields();
      setShowFields(false);
    } catch (error) {
      console.error("Error checking supplier:", error);
      message.error("Failed to check supplier. Please try again.");
    }
    // setAdditionalDetails.dispatch(newSupplier)
  };

  const onCancel = () => {
    form.resetFields();
    if (additionalDetails.length < 1) {
      return;
    } else {
      setShowFields(false);
    }
  };

  const handleAddMore = () => {
    setShowFields(true);
  };

  return (
    <div>
      {showFields ? (
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <FormInput
            name="supplierId"
            label={SUPPLIER_DETAILS_CONSTANTS.SUPPLIER_ID}
            rules={[
              VALIDATION_RULES.supplierIdRequired,
              VALIDATION_RULES.supplierIdMaxLength,
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (!/^\d+$/.test(value) || /^0+$/.test(value)) {
                    return Promise.reject(
                      new Error(
                        "Supplier ID must contain only non-zero numbers."
                      )
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
            suffix={
              <Tooltip placement="bottom" title={SupplierIdtooltipContent}>
                <InfoCircleOutlined
                  style={{
                    color: "rgba(0,0,0,.45)",
                  }}
                />
              </Tooltip>
            }
            AutoFocus={true}
            placeholder={SUPPLIER_DETAILS_CONSTANTS.SUPPLIER_ID}
            // inputType={"number"}
            formFieldType="input"
          />

          <FormInput
            name="countryCode"
            label={SUPPLIER_DETAILS_CONSTANTS.COUNTRY_CODE}
            className="form-item-left-align"
            rules={[VALIDATION_RULES.countryCodeRequired]}
            placeholder={SUPPLIER_DETAILS_CONSTANTS.SELECT_COUNTRY}
            formFieldType="Select"
            options={countries.map((country) => ({
              key: country.isoCode,
              value: country.isoCode,
              label: `${country.isoCode} - ${country.name}`,
            }))}
            optionLabelProp="label"
            showSearch
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
          />

          <Button type="primary" htmlType="submit" className="w-[20%]">
            {SUPPLIER_DETAILS_CONSTANTS.BUTTON_ADD}
          </Button>
          <Button htmlType="button" onClick={onCancel} className="ml-2 w-[20%]">
            {SUPPLIER_DETAILS_CONSTANTS.BUTTON_CANCEL}
          </Button>
        </Form>
      ) : (
        <Button type="primary" onClick={handleAddMore} className="mt-4">
          + Click to Add More
        </Button>
      )}
    </div>
  );
};

export default AdditionalDetails;
